import { authFetch } from "./authFetch";

// Bearer-token auth means a plain <a href> can't carry the token — fetch the
// file through authFetch, then trigger the browser download from the blob.
export async function downloadViaAuthFetch(url, filename) {
  const res = await authFetch(url);
  if (!res.ok) throw new Error("Export failed");

  const blob = await res.blob();
  const objectUrl = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(objectUrl);
}
